import { Component, Input, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-lottie-icon',
  templateUrl: './lottie-icon.component.html',
  styleUrls: ['./lottie-icon.component.scss'],
})
export class LottieIconComponent implements OnInit {
  @Input() lottieJson = '';
  @Input() width = '100px';
  @Input() height = '100px';
  options: AnimationOptions = {};

  ngOnInit(): void {
    this.options = {
      path: this.lottieJson,
    };
  }
}
